export default __webpack_public_path__ + "static/media/section01_pc@2x.9a253cd8.png";